import type { GameConfig } from './types';

export const CONFIG: GameConfig = {
  MAZE_SIZE: 25,
  UNIT_SIZE: 3.0,
  WALL_HEIGHT: 3.0,
  WALK_SPEED: 2.0,
  SPRINT_SPEED: 4.5,
  STAMINA_MAX: 100,
  STAMINA_DRAIN_RATE: 15,
  STAMINA_RECOVERY_RATE: 10,
  BATTERY_MAX: 100,
  BATTERY_DRAIN_RATE: 5,
  SANITY_MAX: 100,
  SANITY_DRAIN_DARK: 1,
  SANITY_DRAIN_NEAR_ENEMY: 4,
  SANITY_RECOVERY_FLASHLIGHT: 0.8,
  SANITY_CRITICAL_THRESHOLD: 20,
  RUNNER_SPEED: 4.0,
  STALKER_SPEED: 1.5,
  TELEPORTER_SPEED: 2.5,
  MONSTER_SPAWN_DELAY: 8000,
  FOG_NEAR: 1.5,
  FOG_FAR: 18,
};

export const HORROR_MESSAGES = [
  'NO MIRES ATRÁS',
  'ESTÁ AQUÍ',
  'NO ESTÁS SOLO',
  'HUYE',
  'TE ENCONTRARÁ',
  'NO HAY SALIDA',
  'ESCUCHA',
  '¿QUE FUE ESE SONIDO?',
  'NO APAGUES LA LUZ',
  'ESTÁ DETRÁS DE TI',
];

export const PLAYER_HEIGHT = 1.7;
export const PLAYER_RADIUS = 0.3;
export const MONSTER_KILL_DISTANCE = 2.8;
export const HIDING_SPOT_DISTANCE = 2.4;

export const RENDIJA_SPAWN_CHANCE = 0.08;
export const RENDIJA_WIDTH = 0.8;
export const FLASHLIGHT_ANGLE = Math.PI / 6;
export const FLASHLIGHT_INTENSITY = 2;
export const FLASHLIGHT_DISTANCE = 12;

export const POWERUP_SPAWN_CHANCE = 0.08;
export const POWERUP_SPEED_DURATION = 10;
export const POWERUP_SPEED_MULTIPLIER = 1.5;
export const POWERUP_INVISIBLE_DURATION = 8;
export const POWERUP_STUN_DURATION = 3;
export const POWERUP_SANITY_AMOUNT = 50;

export const DOOR_SPAWN_CHANCE = 0.15;
